var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus_icon",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 90,
    height: 90,
    x: 0,
    y: 0,
    fill: "#004F89",
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fill: "#FFF",
    d: "M44.5,20 L44.5,20 L44.5,20 C45.8807119,20 47,21.1192881 47,22.5 L47,66.5 C47,67.8807119 45.8807119,69 44.5,69 C43.1192881,69 42,67.8807119 42,66.5 L42,22.5 C42,21.1192881 43.1192881,20 44.5,20 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fill: "#FFF",
    d: "M44.5,20 L44.5,20 L44.5,20 C45.8807119,20 47,21.1192881 47,22.5 L47,66.5 C47,67.8807119 45.8807119,69 44.5,69 C43.1192881,69 42,67.8807119 42,66.5 L42,22.5 C42,21.1192881 43.1192881,20 44.5,20 Z",
    transform: "rotate(90 44.5 44.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.ad9d151864eed857ee527972913cef5b.svg";
export { ForwardRef as ReactComponent };